import {
	SFAA_CONTRACT_OBLIGEES,
	type SfaaContractObligee,
	sfaaContractObligeeLabel,
} from "../../features/sfaa-code/sfaaCodeFilters";
import { SegmentedControls, Text } from "../../primitives";

type SfaaCodeOwnerTypeFilterProps = {
	value: SfaaContractObligee;
	onChange: (value: SfaaContractObligee) => void;
};

export const SfaaCodeOwnerTypeFilter = ({ value, onChange }: SfaaCodeOwnerTypeFilterProps) => (
	<div className="flex items-center justify-between gap-3">
		<Text type="body" color="secondary">
			Owner type
		</Text>
		<SegmentedControls
			value={value}
			onChange={onChange}
			aria-label="Owner type"
			data-testid="sfaa-owner-type-filter"
		>
			{SFAA_CONTRACT_OBLIGEES.map((ownerType) => (
				<SegmentedControls.Segment
					key={ownerType}
					value={ownerType}
					data-testid={`sfaa-owner-type-${ownerType.toLowerCase().replace(/ /g, "-")}`}
				>
					{sfaaContractObligeeLabel(ownerType)}
				</SegmentedControls.Segment>
			))}
		</SegmentedControls>
	</div>
);
